module.exports = __webpack_public_path__ + "img/dialog-icon.75505a93.png";